export default __webpack_public_path__ + "static/media/ba6.f17b7ffb.jpg";